/**
 * RUKSAK Product Recommendation Quiz — Shopify Embed
 * Version: 1.2.0
 *
 * Drop this file into Shopify Admin → Content → Files, then add:
 *   <script src="YOUR_CDN_URL/ruksak-quiz.js" defer></script>
 * to your theme.liquid (before </body>).
 *
 * Trigger the quiz from any button:
 *   <button onclick="RUKSAKQuiz.open()">Find My Product</button>
 *
 * No external dependencies. No React. No build step required.
 */
(function () {
  'use strict';

  // ─── Data ────────────────────────────────────────────────────────────────────

  var VARIANT_IDS = {
    RUKVEST: { '3kg': 42918499254314, '5kg': 42238197858346, '8kg': 42477328334890, '11kg': 42238197923882 },
    RUKSAK:  { '3kg': 42707545522218, '9kg': 42439152500778, '15kg': 42439152599082 },
    STRYDR:  { '4.5kg': 44245024407594, '6.8kg': 44245024440362 },
  };

  var PRODUCTS = {
    RUKVEST: {
      name: 'RUKVEST',
      tagline: 'Weighted Vest',
      imageUrl: 'https://cdn.shopify.com/s/files/1/0591/0872/0682/files/rukvest-hero.jpg?v=1779779648',
      productUrl: 'https://ruksak.com/products/rukvest',
      isSoldOut: false,
      waitlistUrl: 'https://ruksak.com/products/rukvest',
      prices: { '3kg': '$149', '5kg': '$169', '8kg': '$199', '11kg': '$229' },
      recommendation: function (w) { return 'The RUKVEST in ' + w + ' is your perfect fit. Built for people who want to make everyday movement count \u2014 no setup, no fuss. Just throw it on and go.'; },
      features: [
        'Proprietary weighted gel technology moulds to your body',
        'Even weight distribution front and back keeps your posture natural',
        'Adjustable at the sides and front \u2014 stays locked in with zero bounce',
        'Soft, durable lycra shell that\u2019s easy to clean and built to last',
        'Winner of the 2025 Prevention Health & Fitness Awards',
      ],
      weightNotes: {
        '3kg':  'A great starting point. Build the habit first \u2014 the strength will follow.',
        '5kg':  'The sweet spot for most people getting into weighted movement.',
        '8kg':  'A solid load for someone who\u2019s already active. You\u2019ll feel this working from your first walk.',
        '11kg': 'This is the real deal. Built with a double-strap design for serious load and serious results.',
      },
      reviews: [
        'Best purchase I have made! It fits snuggly and the weight distributes evenly.',
        'So comfortable to wear whether you are out hiking or doing your chores of daily life.',
      ],
    },
    RUKSAK: {
      name: 'RUKSAK',
      tagline: 'Weighted Backpack',
      imageUrl: 'https://cdn.shopify.com/s/files/1/0591/0872/0682/files/ruksak-hero.jpg?v=1779779644',
      productUrl: 'https://ruksak.com/products/ruksak-original-starter-pak',
      isSoldOut: false,
      waitlistUrl: 'https://ruksak.com/products/ruksak-original-starter-pak',
      prices: { '3kg': '$299', '9kg': '$349', '15kg': '$399' },
      recommendation: function (w) { return 'The RUKSAK with ' + w + ' of RUKBRIKS is your ideal starting setup. Start where you are and add weight 1kg at a time as your strength builds.'; },
      features: [
        'Adjustable loading in 1kg increments with RUKBRIKS',
        'Premium 1000D Cordura fabric with 10mm EVA padding and YKK zippers',
        'Comes with hydration pack, padded waist belt, and rain cover included',
        'Doubles as a home workout tool with MOLLE webbing for fitness bands',
        '3-year warranty on the pack, lifetime warranty on RUKBRIKS',
      ],
      weightNotes: {
        '3kg':  'Start with 3 RUKBRIKS and build from there. Add a brick when you\u2019re ready.',
        '9kg':  'A strong starting load. You\u2019ve got room to scale all the way to 15kg.',
        '15kg': 'The full setup. 15 RUKBRIKS for maximum resistance.',
      },
      reviews: [
        'The weight bricks sit firmly inside and can be positioned in so many ways.',
        'The ability to add 1kg incremental weight is great for just starting out.',
      ],
    },
    STRYDR: {
      name: 'STRYDR',
      tagline: 'Performance Weighted Vest',
      imageUrl: 'https://cdn.shopify.com/s/files/1/0591/0872/0682/files/strydr-hero.jpg?v=1779779858',
      productUrl: 'https://ruksak.com/products/strydr-weighted-vest',
      isSoldOut: true,
      waitlistUrl: 'https://ruksak.com/products/strydr-weighted-vest',
      prices: { '4.5kg': '$269', '6.8kg': '$299' },
      recommendation: function (w) { return 'The STRYDR in ' + w + ' is built for how you train. Designed for running, HYROX, and high-output sessions where stability at speed matters most.'; },
      features: [
        'Locked-in, second-skin fit stable through running, jumping, and fast-paced movement',
        'Weighted gel technology for balanced load with less bulk',
        'Front zip with adjustable side toggles and longer torso design',
        'Purpose-built for CrossFit, HYROX, circuit work, and sport conditioning',
      ],
      weightNotes: {
        '4.5kg': 'The right entry point for adding resistance to your runs and circuits.',
        '6.8kg': 'For athletes who want meaningful load during high-intensity training.',
      },
      reviews: [
        'Finally a vest that doesn\u2019t bounce around during runs. The fit is incredible.',
        'Perfect for HYROX training. Stays locked in through every movement.',
      ],
    },
  };

  var QUESTIONS = [
    {
      id: 1,
      question: "What\u2019s the main reason you\u2019re looking at weighted gear?",
      options: [
        { label: 'Make my daily walks and movement count for more', scores: { RUKVEST: 3, RUKSAK: 1, STRYDR: 0 } },
        { label: 'Build strength and fitness through structured training', scores: { RUKVEST: 1, RUKSAK: 3, STRYDR: 1 } },
        { label: 'Add resistance to running, HYROX or high-intensity sport', scores: { RUKVEST: 0, RUKSAK: 0, STRYDR: 3 } },
        { label: 'I want something versatile \u2014 walks AND workouts', scores: { RUKVEST: 3, RUKSAK: 2, STRYDR: 0 } },
      ],
    },
    {
      id: 2,
      question: 'How would you describe your fitness level right now?',
      options: [
        { label: 'Just getting started \u2014 little to no regular exercise', scores: { RUKVEST: 2, RUKSAK: 1, STRYDR: 0 }, fitnessLevel: 0 },
        { label: 'Moderately active \u2014 walking or light exercise a few times a week', scores: { RUKVEST: 2, RUKSAK: 2, STRYDR: 0 }, fitnessLevel: 1 },
        { label: 'Active \u2014 training regularly, 3\u20135 times a week', scores: { RUKVEST: 1, RUKSAK: 2, STRYDR: 2 }, fitnessLevel: 2 },
        { label: 'Very fit \u2014 structured program or competitive sport', scores: { RUKVEST: 0, RUKSAK: 1, STRYDR: 3 }, fitnessLevel: 3 },
      ],
    },
    {
      id: 3,
      question: 'To recommend the right weight for you, which range best describes you?',
      options: [
        { label: 'Under 60kg', bodyWeightIndex: 0 },
        { label: '60\u201380kg', bodyWeightIndex: 1 },
        { label: '80\u2013100kg', bodyWeightIndex: 2 },
        { label: 'Over 100kg', bodyWeightIndex: 3 },
      ],
    },
    {
      id: 4,
      question: 'How important is it for you to increase weight over time?',
      options: [
        { label: 'Not important \u2014 I want something simple I can grab and go', scores: { RUKVEST: 3, RUKSAK: 0, STRYDR: 2 }, progressionImportance: 'not' },
        { label: 'Somewhat \u2014 I\u2019d like the option down the track', scores: { RUKVEST: 1, RUKSAK: 2, STRYDR: 1 }, progressionImportance: 'somewhat' },
        { label: 'Very important \u2014 I want to build up my load progressively', scores: { RUKVEST: 0, RUKSAK: 3, STRYDR: 0 }, progressionImportance: 'very' },
      ],
    },
    {
      id: 5,
      question: 'Where will you wear your weighted gear most?',
      options: [
        { label: 'Outdoors \u2014 walks, hikes, trails', scores: { RUKVEST: 2, RUKSAK: 3, STRYDR: 0 } },
        { label: 'At the gym or at home for workouts', scores: { RUKVEST: 1, RUKSAK: 0, STRYDR: 3 } },
        { label: 'A mix of both', scores: { RUKVEST: 3, RUKSAK: 1, STRYDR: 1 } },
      ],
    },
    {
      id: 6,
      question: 'Have you ever used a weighted vest or weighted backpack before?',
      options: [
        { label: 'Nope, this is brand new for me', scores: { RUKVEST: 2, RUKSAK: 1, STRYDR: 0 } },
        { label: "I\u2019ve tried one but didn\u2019t stick with it", scores: { RUKVEST: 2, RUKSAK: 2, STRYDR: 0 } },
        { label: 'Yeah, I use one regularly and I\u2019m ready to level up', scores: { RUKVEST: 0, RUKSAK: 2, STRYDR: 2 } },
      ],
    },
  ];

  // ─── Weight Matrices ─────────────────────────────────────────────────────────
  // Indexed [fitnessLevel][bodyWeightIndex] — fitness bonus applied before lookup

  var RUKVEST_MATRIX = [
    ['3kg',  '5kg',  '5kg',  '8kg' ],  // Just getting started
    ['5kg',  '5kg',  '8kg',  '8kg' ],  // Moderately active
    ['8kg',  '8kg',  '11kg', '11kg'],  // Active
    ['8kg',  '11kg', '11kg', '11kg'],  // Very fit
  ];
  var RUKSAK_MATRIX = [
    ['3kg',  '9kg',  '9kg',  '9kg' ],  // Just getting started
    ['9kg',  '9kg',  '9kg',  '15kg'],  // Moderately active
    ['9kg',  '9kg',  '15kg', '15kg'],  // Active
    ['9kg',  '15kg', '15kg', '15kg'],  // Very fit
  ];
  var STRYDR_MATRIX = [
    ['4.5kg', '4.5kg', '4.5kg', '6.8kg'],
    ['4.5kg', '4.5kg', '6.8kg', '6.8kg'],
    ['4.5kg', '6.8kg', '6.8kg', '6.8kg'],
    ['6.8kg', '6.8kg', '6.8kg', '6.8kg'],
  ];
  var FITNESS_BONUS = [0, 0, 0, 0]; // no bonus — values baked directly into matrix

  // ─── Scoring Engine ──────────────────────────────────────────────────────────

  function calculateResult(answers) {
    var scores = { RUKVEST: 0, RUKSAK: 0, STRYDR: 0 };
    var scoringQs = [0, 1, 3, 4, 5]; // Q1, Q2, Q4, Q5, Q6 (0-indexed)
    scoringQs.forEach(function (qi) {
      var opt = QUESTIONS[qi].options[answers[qi]];
      if (opt && opt.scores) {
        scores.RUKVEST += opt.scores.RUKVEST;
        scores.RUKSAK  += opt.scores.RUKSAK;
        scores.STRYDR  += opt.scores.STRYDR;
      }
    });

    var ranked = Object.keys(scores).sort(function (a, b) { return scores[b] - scores[a]; });
    var primary   = ranked[0];
    var runnerUp  = ranked[1];

    // Tiebreaker: RUKVEST vs RUKSAK → Q4 progression importance
    if (scores.RUKVEST === scores.RUKSAK && primary !== 'STRYDR') {
      var prog = QUESTIONS[3].options[answers[3]].progressionImportance;
      primary  = prog === 'very' ? 'RUKSAK' : 'RUKVEST';
      runnerUp = primary === 'RUKSAK' ? 'RUKVEST' : 'RUKSAK';
    }

    var fitnessLevel     = QUESTIONS[1].options[answers[1]].fitnessLevel || 0;
    var rawBWI           = QUESTIONS[2].options[answers[2]].bodyWeightIndex || 0;
    var bwi              = Math.min(3, rawBWI + FITNESS_BONUS[fitnessLevel]);

    function getWeight(prod) {
      if (prod === 'RUKVEST') return RUKVEST_MATRIX[fitnessLevel][bwi];
      if (prod === 'RUKSAK')  return RUKSAK_MATRIX[fitnessLevel][bwi];
      return STRYDR_MATRIX[fitnessLevel][bwi];
    }

    var pw = getWeight(primary);
    var rw = getWeight(runnerUp);

    return {
      primaryProduct:    primary,
      primaryWeight:     pw,
      primaryVariantId:  VARIANT_IDS[primary][pw],
      runnerUpProduct:   runnerUp,
      runnerUpWeight:    rw,
      runnerUpVariantId: VARIANT_IDS[runnerUp][rw],
      scores:            scores,
    };
  }

  // ─── Styles ──────────────────────────────────────────────────────────────────

  var CSS = [
    '#ruksak-quiz-overlay{position:fixed;inset:0;z-index:2147483647;display:flex;align-items:flex-end;justify-content:center;background:rgba(0,0,0,0.7);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);opacity:0;transition:opacity 220ms ease;pointer-events:none;}',
    '#ruksak-quiz-overlay.rq-visible{opacity:1;pointer-events:auto;}',
    '@media(min-width:640px){#ruksak-quiz-overlay{align-items:center;}}',
    '#ruksak-quiz-modal{width:100%;max-width:420px;max-height:92vh;background:#1c1c1c;border-radius:20px 20px 0 0;display:flex;flex-direction:column;overflow:hidden;transform:translateY(40px);transition:transform 280ms cubic-bezier(0.23,1,0.32,1);font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:#fff;box-shadow:0 -8px 40px rgba(0,0,0,0.6);}',
    '@media(min-width:640px){#ruksak-quiz-modal{border-radius:20px;transform:scale(0.95) translateY(0);}}',
    '#ruksak-quiz-overlay.rq-visible #ruksak-quiz-modal{transform:translateY(0);}',
    '@media(min-width:640px){#ruksak-quiz-overlay.rq-visible #ruksak-quiz-modal{transform:scale(1);}}',
    '.rq-header{flex-shrink:0;display:flex;align-items:center;justify-content:space-between;padding:18px 20px 12px;}',
    '.rq-logo{height:28px;width:auto;object-fit:contain;}',
    '.rq-close{width:32px;height:32px;border-radius:50%;background:rgba(255,255,255,0.1);border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;color:rgba(255,255,255,0.6);font-size:18px;line-height:1;transition:background 150ms,color 150ms;flex-shrink:0;}',
    '.rq-close:hover{background:rgba(255,255,255,0.2);color:#fff;}',
    '.rq-progress-text{font-size:12px;color:rgba(255,255,255,0.4);font-weight:500;}',
    '.rq-body{flex:1;overflow-y:auto;padding:0 20px 24px;-webkit-overflow-scrolling:touch;}',
    '.rq-body::-webkit-scrollbar{width:4px;} .rq-body::-webkit-scrollbar-track{background:transparent;} .rq-body::-webkit-scrollbar-thumb{background:rgba(255,255,255,0.15);border-radius:2px;}',
    /* Intro screen */
    '.rq-intro-img{width:100%;height:160px;object-fit:cover;object-position:center;border-radius:12px;margin-bottom:20px;display:block;}',
    '.rq-intro-title{font-size:22px;font-weight:900;line-height:1.2;margin:0 0 10px;letter-spacing:-0.3px;color: #ffffff;}',
    '.rq-intro-sub{font-size:14px;color:rgba(255,255,255,0.55);margin:0 0 22px;line-height:1.5;}',
    '.rq-btn-primary{width:100%;padding:16px;background:#FBDD4F;color:#171717;border:none;border-radius:12px;font-size:15px;font-weight:900;letter-spacing:0.5px;text-transform:uppercase;cursor:pointer;transition:background 150ms,transform 100ms;display:flex;align-items:center;justify-content:center;gap:8px;}',
    '.rq-btn-primary:hover{background:#fce96a;} .rq-btn-primary:active{transform:scale(0.98);}',
    /* Question screen */
    '.rq-q-label{font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#FBDD4F;margin:0 0 10px;}',
    '.rq-q-text{font-size:19px;font-weight:800;line-height:1.3;margin:0 0 20px;letter-spacing:-0.2px; color: #ffffff;}',
    '.rq-options{display:flex;flex-direction:column;gap:10px;}',
    '.rq-option{padding:14px 16px;background:rgba(255,255,255,0.05);border:1.5px solid rgba(255,255,255,0.1);border-radius:12px;cursor:pointer;font-size:14px;font-weight:500;color:rgba(255,255,255,0.85);text-align:left;transition:border-color 150ms,background 150ms,transform 100ms;line-height:1.4;}',
    '.rq-option:hover{border-color:rgba(251,221,79,0.5);background:rgba(251,221,79,0.06);} .rq-option:active{transform:scale(0.99);}',
    '.rq-option.rq-selected{border-color:#FBDD4F;background:rgba(251,221,79,0.1);color:#fff;}',
    /* Progress bar */
    '.rq-prog-bar{height:3px;background:rgba(255,255,255,0.08);border-radius:2px;margin-bottom:20px;overflow:hidden;}',
    '.rq-prog-fill{height:100%;background:#FBDD4F;border-radius:2px;transition:width 300ms cubic-bezier(0.23,1,0.32,1);}',
    /* Back button */
    '.rq-back{background:none;border:none;color:rgba(255,255,255,0.4);font-size:13px;cursor:pointer;padding:0;margin-bottom:16px;display:flex;align-items:center;gap:4px;transition:color 150ms;}',
    '.rq-back:hover{color:rgba(255,255,255,0.8);}',
    /* Result screen */
    '.rq-result-badge{display:inline-block;font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#171717;background:#FBDD4F;padding:4px 10px;border-radius:20px;margin-bottom:14px;}',
    '.rq-result-img{width:100%;height:180px;object-fit:cover;border-radius:12px;margin-bottom:16px;display:block;}',
    '.rq-result-name{font-size:24px;font-weight:900;margin:0 0 4px;letter-spacing:-0.3px; color:#ffffff;}',
    '.rq-result-tagline{font-size:13px;color:rgba(255,255,255,0.45);margin:0 0 6px;font-weight:500;text-transform:uppercase;letter-spacing:0.8px;}',
    '.rq-result-price{font-size:22px;font-weight:900;color:#FBDD4F;margin:0 0 12px;}',
    '.rq-result-rec{font-size:14px;color:rgba(255,255,255,0.7);line-height:1.55;margin:0 0 16px;}',
    '.rq-result-note{background:rgba(251,221,79,0.08);border:1px solid rgba(251,221,79,0.2);border-radius:10px;padding:12px 14px;font-size:13px;color:rgba(255,255,255,0.7);line-height:1.5;margin-bottom:16px;}',
    '.rq-features{list-style:none;padding:0;margin:0 0 16px;}',
    '.rq-features li{font-size:13px;color:rgba(255,255,255,0.65);padding:6px 0;border-bottom:1px solid rgba(255,255,255,0.06);display:flex;align-items:flex-start;gap:8px;line-height:1.4;}',
    '.rq-features li:last-child{border-bottom:none;}',
    '.rq-feat-dot{width:6px;height:6px;border-radius:50%;background:#FBDD4F;flex-shrink:0;margin-top:5px;}',
    '.rq-reviews{display:flex;flex-direction:column;gap:8px;margin-bottom:20px;}',
    '.rq-review{background:rgba(255,255,255,0.04);border-radius:10px;padding:12px 14px;font-size:13px;color:rgba(255,255,255,0.6);line-height:1.5;font-style:italic;}',
    '.rq-atc{width:100%;padding:16px;background:#FBDD4F;color:#171717;border:none;border-radius:12px;font-size:15px;font-weight:900;letter-spacing:0.5px;text-transform:uppercase;cursor:pointer;transition:background 150ms,transform 100ms;margin-bottom:10px;}',
    '.rq-atc:hover{background:#fce96a;} .rq-atc:active{transform:scale(0.98);}',
    '.rq-atc:disabled{opacity:0.6;cursor:not-allowed;}',
    '.rq-atc-loading{display:none;} .rq-atc.loading .rq-atc-text{display:none;} .rq-atc.loading .rq-atc-loading{display:inline;}',
    '.rq-waitlist{width:100%;padding:16px;background:transparent;color:#FBDD4F;border:1.5px solid #FBDD4F;border-radius:12px;font-size:15px;font-weight:900;letter-spacing:0.5px;text-transform:uppercase;cursor:pointer;transition:background 150ms;text-decoration:none;display:block;text-align:center;box-sizing:border-box;margin-bottom:10px;}',
    '.rq-waitlist:hover{background:rgba(251,221,79,0.1);}',
    '.rq-disclaimer{text-align:center;font-size:11px;color:#ffffff;line-height:1.5;margin:8px 0 0;padding:0 8px; font-size:13px; font-weight:bold;}',
    '.rq-disclaimer-link{color:#FFFFFF;;text-decoration:underline;text-underline-offset:2px;transition:color 150ms;}',
    '.rq-disclaimer-link:hover{color:#FFFFFF; font-size:13px; font-weight:bold;}',
    '.rq-retake{width:100%;padding:12px;background:transparent;color:rgba(255,255,255,0.35);border:none;font-size:13px;cursor:pointer;transition:color 150ms;}',
    '.rq-retake:hover{color:rgba(255,255,255,0.7);}',
    '.rq-runner-up{margin-top:4px;padding:14px 16px;background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.08);border-radius:12px;display:flex;align-items:center;justify-content:space-between;gap:12px;}',
    '.rq-runner-up-info{font-size:13px;color:rgba(255,255,255,0.5);} .rq-runner-up-name{font-size:14px;font-weight:700;color:rgba(255,255,255,0.8);}',
    '.rq-runner-up-link{font-size:12px;font-weight:700;color:#FBDD4F;text-decoration:none;white-space:nowrap;} .rq-runner-up-link:hover{text-decoration:underline;}',
    /* Sold out badge */
    '.rq-sold-out-badge{display:inline-block;font-size:11px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:#fff;background:rgba(255,255,255,0.15);padding:3px 8px;border-radius:20px;margin-left:8px;}',
  ].join('');

  // ─── Logo URL ─────────────────────────────────────────────────────────────────
  // The transparent RUKSAK logo hosted on the Manus CDN (same lifecycle as the embed)
  var LOGO_URL = 'https://cdn.shopify.com/s/files/1/0591/0872/0682/files/quiz-logo.png?v=1779773905';
  var HERO_URL = 'https://cdn.shopify.com/s/files/1/0591/0872/0682/files/quiz-hero.jpg?v=1779773905';

  // ─── State ───────────────────────────────────────────────────────────────────

  var state = {
    open: false,
    screen: 'intro',   // 'intro' | 'question' | 'result'
    currentQ: 0,       // 0-indexed
    answers: {},       // { 0: optionIndex, 1: optionIndex, ... }
    result: null,
  };

  // ─── DOM helpers ─────────────────────────────────────────────────────────────

  function el(tag, attrs, children) {
    var e = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'className') e.className = attrs[k];
      else if (k === 'innerHTML') e.innerHTML = attrs[k];
      else if (k === 'style') Object.assign(e.style, attrs[k]);
      else e.setAttribute(k, attrs[k]);
    });
    if (children) children.forEach(function (c) { if (c) e.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return e;
  }

  function svgArrow() {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('width', '14'); s.setAttribute('height', '14'); s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '2.5'); s.setAttribute('stroke-linecap', 'round'); s.setAttribute('stroke-linejoin', 'round');
    s.innerHTML = '<polyline points="9 18 15 12 9 6"></polyline>';
    return s;
  }

  function svgBack() {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('width', '14'); s.setAttribute('height', '14'); s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '2.5'); s.setAttribute('stroke-linecap', 'round'); s.setAttribute('stroke-linejoin', 'round');
    s.innerHTML = '<polyline points="15 18 9 12 15 6"></polyline>';
    return s;
  }

  // ─── Render ──────────────────────────────────────────────────────────────────

  var overlay, modal, header, body;

  function injectStyles() {
    if (document.getElementById('ruksak-quiz-styles')) return;
    var style = document.createElement('style');
    style.id = 'ruksak-quiz-styles';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function buildShell() {
    if (document.getElementById('ruksak-quiz-overlay')) return;

    overlay = el('div', { id: 'ruksak-quiz-overlay' });
    modal   = el('div', { id: 'ruksak-quiz-modal' });

    // Header
    header = el('div', { className: 'rq-header' });
    var logo = el('img', { className: 'rq-logo', src: LOGO_URL, alt: 'RUKSAK' });
    var headerRight = el('div', { style: { display: 'flex', alignItems: 'center', gap: '10px' } });
    var progressText = el('span', { className: 'rq-progress-text' });
    var closeBtn = el('button', { className: 'rq-close', 'aria-label': 'Close quiz', innerHTML: '&times;' });
    closeBtn.addEventListener('click', closeQuiz);
    headerRight.appendChild(progressText);
    headerRight.appendChild(closeBtn);
    header.appendChild(logo);
    header.appendChild(headerRight);

    body = el('div', { className: 'rq-body' });

    modal.appendChild(header);
    modal.appendChild(body);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    // Close on backdrop click
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeQuiz(); });
    // Prevent scroll on body when open
    modal.addEventListener('touchmove', function (e) { e.stopPropagation(); }, { passive: true });
  }

  function updateProgressText() {
    var pt = header.querySelector('.rq-progress-text');
    if (state.screen === 'question') {
      pt.textContent = (state.currentQ + 1) + ' of ' + QUESTIONS.length;
    } else {
      pt.textContent = '';
    }
  }

  function render() {
    updateProgressText();
    body.innerHTML = '';
    if (state.screen === 'intro')    renderIntro();
    else if (state.screen === 'question') renderQuestion();
    else if (state.screen === 'result')   renderResult();
  }

  function renderIntro() {
    var img = el('img', { className: 'rq-intro-img', src: HERO_URL, alt: 'RUKSAK Products' });
    var title = el('h2', { className: 'rq-intro-title', innerHTML: 'Not sure which RUK product is right for you?' });
    var sub = el('p', { className: 'rq-intro-sub', innerHTML: 'Answer 6 quick questions and we\u2019ll recommend the perfect product and weight for your goals, fitness level, and lifestyle.' });
    var btn = el('button', { className: 'rq-btn-primary' });
    btn.appendChild(document.createTextNode("LET\u2019S GO"));
    btn.appendChild(svgArrow());
    btn.addEventListener('click', function () {
      state.screen = 'question';
      state.currentQ = 0;
      render();
    });
    body.appendChild(img);
    body.appendChild(title);
    body.appendChild(sub);
    body.appendChild(btn);
  }

  function renderQuestion() {
    var q = QUESTIONS[state.currentQ];
    var pct = ((state.currentQ) / QUESTIONS.length) * 100;

    // Progress bar
    var progBar = el('div', { className: 'rq-prog-bar' });
    var progFill = el('div', { className: 'rq-prog-fill', style: { width: pct + '%' } });
    progBar.appendChild(progFill);

    // Back button (not on Q1)
    var backBtn = null;
    if (state.currentQ > 0) {
      backBtn = el('button', { className: 'rq-back' });
      backBtn.appendChild(svgBack());
      backBtn.appendChild(document.createTextNode(' Back'));
      backBtn.addEventListener('click', function () {
        state.currentQ--;
        render();
      });
    }

    var label = el('p', { className: 'rq-q-label', innerHTML: 'Question ' + (state.currentQ + 1) });
    var qText = el('h3', { className: 'rq-q-text', innerHTML: q.question });
    var opts = el('div', { className: 'rq-options' });

    q.options.forEach(function (opt, i) {
      var btn = el('button', { className: 'rq-option' + (state.answers[state.currentQ] === i ? ' rq-selected' : '') });
      btn.textContent = opt.label;
      btn.addEventListener('click', function () {
        state.answers[state.currentQ] = i;
        // Auto-advance after short delay
        setTimeout(function () {
          if (state.currentQ < QUESTIONS.length - 1) {
            state.currentQ++;
            render();
          } else {
            state.result = calculateResult(state.answers);
            state.screen = 'result';
            render();
          }
        }, 180);
        // Highlight immediately
        opts.querySelectorAll('.rq-option').forEach(function (b) { b.classList.remove('rq-selected'); });
        btn.classList.add('rq-selected');
      });
      opts.appendChild(btn);
    });

    if (backBtn) body.appendChild(backBtn);
    body.appendChild(progBar);
    body.appendChild(label);
    body.appendChild(qText);
    body.appendChild(opts);
  }

  function renderResult() {
    var r = state.result;
    var prod = PRODUCTS[r.primaryProduct];
    var runnerProd = PRODUCTS[r.runnerUpProduct];
    var isSoldOut = prod.isSoldOut;

    // Badge
    var badge = el('div', { className: 'rq-result-badge', innerHTML: 'Your Match' });

    // Product image
    var img = el('img', { className: 'rq-result-img', src: prod.imageUrl, alt: prod.name });

    // Name + tagline
    var name = el('h2', { className: 'rq-result-name' });
    name.textContent = prod.name + ' ' + r.primaryWeight;
    if (isSoldOut) {
      var soBadge = el('span', { className: 'rq-sold-out-badge', innerHTML: 'Sold Out' });
      name.appendChild(soBadge);
    }
    var tagline = el('p', { className: 'rq-result-tagline', innerHTML: prod.tagline });
    var price = el('p', { className: 'rq-result-price', innerHTML: prod.prices[r.primaryWeight] || '' });

    // Recommendation sentence
    var rec = el('p', { className: 'rq-result-rec', innerHTML: prod.recommendation(r.primaryWeight) });

    // Weight note
    var note = el('div', { className: 'rq-result-note', innerHTML: prod.weightNotes[r.primaryWeight] || '' });

    // Features
    var featList = el('ul', { className: 'rq-features' });
    prod.features.forEach(function (f) {
      var li = el('li');
      var dot = el('span', { className: 'rq-feat-dot' });
      li.appendChild(dot);
      li.appendChild(document.createTextNode(f));
      featList.appendChild(li);
    });

    // Reviews
    var reviews = el('div', { className: 'rq-reviews' });
    prod.reviews.forEach(function (rv) {
      var r2 = el('div', { className: 'rq-review', innerHTML: '\u201c' + rv + '\u201d' });
      reviews.appendChild(r2);
    });

    // CTA
    var ctaSection = el('div');
    if (isSoldOut) {
      var wl = el('a', { className: 'rq-waitlist', href: prod.waitlistUrl, target: '_blank', rel: 'noopener', innerHTML: 'JOIN THE WAITLIST' });
      ctaSection.appendChild(wl);
    } else {
      var atcBtn = el('button', { className: 'rq-atc' });
      atcBtn.innerHTML = '<span class="rq-atc-text">ADD TO CART \u2014 ' + (prod.prices[r.primaryWeight] || '') + '</span><span class="rq-atc-loading">Adding\u2026</span>';
      atcBtn.addEventListener('click', function () {
        atcBtn.classList.add('loading');
        atcBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: r.primaryVariantId, quantity: 1 }),
        })
        .then(function (res) { return res.json(); })
        .then(function () {
          // Redirect to cart
          window.location.href = '/cart';
        })
        .catch(function () {
          atcBtn.classList.remove('loading');
          atcBtn.disabled = false;
          alert('Something went wrong adding to cart. Please try again.');
        });
      });
      ctaSection.appendChild(atcBtn);
    }

    // Runner-up
    var ruSection = el('div', { className: 'rq-runner-up' });
    var ruInfo = el('div');
    var ruLabel = el('div', { className: 'rq-runner-up-info', innerHTML: 'Also a great fit:' });
    var ruName = el('div', { className: 'rq-runner-up-name', innerHTML: runnerProd.name + ' ' + r.runnerUpWeight });
    ruInfo.appendChild(ruLabel);
    ruInfo.appendChild(ruName);
    var ruLink = el('a', { className: 'rq-runner-up-link', href: runnerProd.productUrl, target: '_blank', rel: 'noopener', innerHTML: 'View \u2192' });
    ruSection.appendChild(ruInfo);
    ruSection.appendChild(ruLink);

    // Retake
    var retake = el('button', { className: 'rq-retake', innerHTML: 'Retake quiz' });
    retake.addEventListener('click', function () {
      state.screen = 'intro';
      state.answers = {};
      state.result = null;
      render();
    });

    // Disclaimer — shown immediately below the badge, before the product image
    var disclaimer = el('p', { className: 'rq-disclaimer' });
    disclaimer.innerHTML = 'Suggestion only: please use your fitness level, injuries, and current activity level into account. If in doubt go lighter. <a href="https://ruksak.com/pages/beginners-guide-to-rucking" target="_blank" rel="noopener noreferrer" class="rq-disclaimer-link">Refer to our resources page</a> for further help with your selection.<BR>';

    body.appendChild(badge);
    body.appendChild(disclaimer);
    body.appendChild(img);
    body.appendChild(name);
    body.appendChild(tagline);
    body.appendChild(price);
    body.appendChild(rec);
    body.appendChild(note);
    body.appendChild(featList);
    body.appendChild(reviews);
    body.appendChild(ctaSection);
    body.appendChild(ruSection);
    body.appendChild(retake);
  }

  // ─── Open / Close ─────────────────────────────────────────────────────────────

  function openQuiz() {
    injectStyles();
    buildShell();
    // Reset to intro if starting fresh
    if (state.screen === 'intro') {
      state.answers = {};
      state.result = null;
      state.currentQ = 0;
    }
    render();
    // Trigger animation on next frame
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('rq-visible');
        document.body.style.overflow = 'hidden';
      });
    });
    state.open = true;
  }

  function closeQuiz() {
    if (!overlay) return;
    overlay.classList.remove('rq-visible');
    document.body.style.overflow = '';
    state.open = false;
    // Reset to intro after close animation
    setTimeout(function () {
      state.screen = 'intro';
      state.answers = {};
      state.result = null;
      state.currentQ = 0;
    }, 300);
  }

 // ─── Public API ───────────────────────────────────────────────────────────────

  window.RUKSAKQuiz = {
    open:  openQuiz,
    close: closeQuiz,
  };

  // Keyboard: Escape to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.open) closeQuiz();
  });

  document.addEventListener('click', function (e) {
  var link = e.target.closest('a[href="#quiz"]');
  if (link) {
    e.preventDefault();
    openQuiz();
  }
});

if (window.location.hash === '#quiz') openQuiz();

})();
